import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Tab, TabList } from "@fluentui/react-components";
import { RootState } from "../../../redux/store";
import { checkUserPermission, convertStringToArray } from "../../../utils";
import { UserPermissionsList } from "../../../config";

type Props = {
  active: "fees" | "distribution";
  commissionId?: string;
};

// Fees/Charges | Distribution sub tabs. Distribution needs a selected fee and
// follows the same permission and env flags as the case Distribution tab.
function FeesChargesTabs({ active, commissionId }: Props) {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const loggedUser = useSelector((state: RootState) => state.authUser);

  const canDistribute =
    checkUserPermission(loggedUser, UserPermissionsList.ALLOW_ADD_DISTRIBUTION) ||
    checkUserPermission(loggedUser, UserPermissionsList.ALLOW_UPDATE_DISTRIBUTION);
  const hidden = convertStringToArray(
    process.env.REACT_APP_HIDE_CTA_BUTTON,
  ).includes("payment_commission_distribution_hide_button");
  const disabled = convertStringToArray(
    process.env.REACT_APP_DISABLE_CTA_BUTTON,
  ).includes("payment_commission_distribution_disable_button");

  if (!canDistribute || hidden) return null;

  const basePath = `/clients/${clientId}/fees-charges`;
  return (
    <TabList
      selectedValue={active}
      onTabSelect={(_, data) =>
        navigate(
          data.value === "distribution"
            ? `${basePath}/${commissionId}/distribution`
            : commissionId
              ? `${basePath}/${commissionId}/view`
              : basePath,
        )
      }
    >
      <Tab value="fees">Fees/Charges</Tab>
      <Tab value="distribution" disabled={!commissionId || disabled}>
        Distribution
      </Tab>
    </TabList>
  );
}

export default FeesChargesTabs;
